<template lang="pug">
  .container.grid-lg.py-2
    load-manager(:status="status")
      .card(v-if='current')
        .card-body
          .form-group.py-2
            abbr {{ 'doc_publicacao.descricao' | tModel }}
            div {{ current.descricao }}
          .columns
            .column.col-auto
              .form-group.py-2
                abbr {{ 'doc_publicacao.numero' | tModel }}
                div {{ current.numero }}/{{ current.ano }}
            .column.col-auto
              .form-group.py-2
                abbr {{ 'doc_publicacao.publicado_em' | tModel }}
                div {{ current.publicado_em | date('DD/MM/YYYY') }}
            .column.col-auto
              .form-group.py-2
                abbr {{ 'doc_publicacao.situacao' | tModel }}
                div {{ current | enums('doc_publicacao.situacao') }}
          .columns
            .column.col-auto
              .form-group.py-2
                abbr {{ 'doc_publicacao.created_at' | tModel }}
                div {{ current.created_at | date }}
            .column.col-auto
              .form-group.py-2
                abbr {{ 'doc_publicacao.updated_at' | tModel }}
                div {{ current.updated_at | date }}
            .column.col-auto
              .form-group.py-2
                abbr {{ 'doc_publicacao.usuario' | tModel }}
                div {{ current.usuario.nome }}
        .card-body
          .divider
          label.form-label {{ 'doc_publicacao.docs' | tModel }}
          div(v-if='current.docs && current.docs.length')
            span.chip(v-for='doc in current.docs' :key='String(doc.id)') {{ doc.numero }}/{{ doc.ano }}
              a.btn.btn-link(target='_blank' :href='doc.url')
                btn-icon(name='print')
              router-link.btn.btn-link.text-error(
                v-if='current.permite_editar'
                :to='{name: "fiscalizacao.docPublicacoes.show.desvincularDoc", params: { docId: doc.id, id: current.id }}'
              )
                btn-icon(name='delete')
          div(v-else)
            i.fa.fa-list
            abbr  Nenum documento vinculado
          div
            router-link.btn.btn-link(
              v-if='current.permite_editar'
              :to='{ name: "fiscalizacao.docPublicacoes.show.vincularDoc" }'
            )
              btn-content(name='new' label='Vincular documentos')
        .card-footer
          .divider
          .columns
            .column
              a.btn.btn-link(@click="$router.back()")
                btn-content(name='back')
            .column.col-auto
              a.btn.btn-link(target='_blank' :href='current.url')
                btn-content(name='print')
            .column.col-auto(v-if='current.permite_editar')
              router-link.btn.btn-link.text-error(:to='{ name: "fiscalizacao.docPublicacoes.show.cancelar" }')
                btn-content(name='cancel')
              router-link.btn.btn-link.text-primary(:to='{ name: "fiscalizacao.docPublicacoes.show.encerrar" }')
                btn-content(name='check' label='Encerrar')
              router-link.btn.btn-link(:to='{ name: "fiscalizacao.docPublicacoes.edit" }')
                btn-content(name='edit')
    router-view
</template>

<script>
import showMixin, { vuexDefaultMapping } from '@/mixins/show'

export default {
  vuex: {
    'fiscalizacao/docPublicacoes': vuexDefaultMapping,
  },
  mixins: [showMixin],
}
</script>
